import React, { useEffect, useState } from "react";
import { useGetStoresQuery } from "../../../api/stores";
import { sortArrOfData } from "../../../constants/sorting";
import { useSelector } from "react-redux";
import MultiSelect from "../../../constants/multiSelectDropdown";

/**
 * Multi-select hub filter (used on the All Shifts page).
 *
 * Mirrors the store-fetching / metro_manager filtering of the single
 * HubSelect, but lets the user pick several hubs at once.
 *
 * Props:
 *  - value:    array of { value, label, id }
 *  - onChange: (selectedOptions) => void  (array, or [] when cleared)
 *  - valueKey: which store field to use as the option `value`
 *              ("_id" by default, "name" for the Orders page convention).
 *              `id` is always the store _id.
 */
function HubMultiSelect({ value, onChange, isLoading, styles, width, valueKey = "_id" }) {
  const { data: stores, isFetching: storesLoadingStatus } = useGetStoresQuery(
    null,
    { refetchOnMountOrArgChange: false }
  );
  const currentUser = useSelector((state) => state.auth.currentUser);

  const [hubList, setHubList] = useState([]);

  useEffect(() => {
    if (!stores) return;
    let availableHubs;
    if (currentUser?.role === "metro_manager") {
      const metro_manager_metros = JSON.parse(
        localStorage.getItem("user_metro")
      );
      availableHubs = stores.filter((store) =>
        metro_manager_metros?.some((metro) => store.metro === metro)
      );
    } else {
      availableHubs = sortArrOfData(stores, "name");
    }
    setHubList(
      (availableHubs || []).map((store) => ({
        value: store[valueKey],
        label: store.name,
        id: store._id,
      }))
    );
  }, [stores, storesLoadingStatus, currentUser, valueKey]);

  return (
    <MultiSelect
      placeholder="Select Hubs"
      itemData={hubList}
      value={value || []}
      onChange={(selected) => onChange(selected || [])}
      isLoading={isLoading}
      styles={styles}
      width={width}
    />
  );
}

export default HubMultiSelect;
